export enum PAYMENT_STATUS {
  CHECKOUT_SUCCESS = "checkout.session.async_payment_succeeded",
  INVOICE_SUCCESS = "invoice.payment_succeeded",
  SESSION_SUCCESS = "checkout.session.completed",
  CHARGE_SUCCESS = "charge.succeeded",
  PAYMENT_SUCCESS = "payment_intent.succeeded",
}
